import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGetColor } from 'modules/v2/foundation/theme';
const overlayFadeIn = keyframes ` 
  from {
    background-color: transparent;
    // without opacity the animation is not smooth
    backdrop-filter: blur(${pxToRem(1.5)}) opacity(0);
  } 
  to {
    background-color: ${themeGetColor('gray.50', 0.24)};
    backdrop-filter: blur(${pxToRem(1.5)}) opacity(1);
  }
`;
export const Container = styled.div `
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: -webkit-fill-available; // webkit hack
  ${(props) => props.$overlay &&
    css `
      animation: 0.2s ${overlayFadeIn} forwards;
    `};
`;
